import { Card, CardBody, Grid } from '@statsbomb/kitbag-components';
import { _VideoPlayer } from '@statsbomb/video-client-js';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import qs from 'qs';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router-dom';
import {
  addToCurrentPlaylistAtom,
  currentlyPlayingAtom,
  playSpecificEntryByUrlAtom,
} from '../../atoms/playlist';
import { selectedMetadataAtom } from '../../atoms/selectedMetadata';
import { selectedVideoSourceURLAtom } from '../../atoms/selectedVideoData';
import CardHeader from '../../components/CardHeader';
import MetadataSelection from '../../components/MetadataSelection';
import { SelectSource } from '../../components/SelectSource/SelectSource';
import SelectVideo from '../../components/SelectVideo';
import TrimVideo from '../../components/TrimVideo';

export function Trim() {
  const { search } = useLocation();
  const query = qs.parse(search, { ignoreQueryPrefix: true });

  const { url: providedUrl } = query;

  const addToCurrentPlaylist = useSetAtom(addToCurrentPlaylistAtom);
  const setSelectedVideo = useSetAtom(selectedVideoSourceURLAtom);
  const currentlyPlaying = useAtomValue(currentlyPlayingAtom);
  const setVideoPlaying = useSetAtom(playSpecificEntryByUrlAtom);

  const [selectedMetadata, setSelectedMetadata] = useAtom(selectedMetadataAtom);

  const [url, setUrl] = useState(providedUrl || undefined);

  const utiliseNewUrl = (newUrl) => {
    setUrl(newUrl);
    setSelectedVideo(newUrl);
    addToCurrentPlaylist({ shareUrl: newUrl, url: newUrl });
    setVideoPlaying(newUrl);
  };

  const handleUrlChange = (event) => {
    utiliseNewUrl(event.target.value);
  };

  const onSubmitCompleted = () =>
    setSelectedMetadata({ ...selectedMetadata, period: undefined });

  useEffect(() => {
    if (providedUrl) {
      utiliseNewUrl(providedUrl);
    }
  }, [providedUrl]);

  return (
    <Grid>
      <Grid item xs={12} xl={6}>
        <div>
          <Card>
            <CardBody>
              <SelectVideo
                id="select-video"
                onChange={handleUrlChange}
                value={url}
              />
            </CardBody>
          </Card>
        </div>
        {/* Disabled as known prefix for dev only internal components */}
        {/* eslint-disable-next-line react/jsx-pascal-case */}
        <_VideoPlayer autoPlay src={url} />
      </Grid>
      <Grid item xs={12} xl={6}>
        {currentlyPlaying?.url && (
          <Grid>
            <Grid item xs={12}>
              <Card>
                <CardHeader>
                  <FormattedMessage
                    defaultMessage="Video Information"
                    id="41410"
                  />
                </CardHeader>
                <CardBody>
                  <MetadataSelection />
                  <SelectSource
                    sport={selectedMetadata.sport}
                    urlWithTranscodeOnly
                  />
                </CardBody>
              </Card>
            </Grid>
            <Grid item xs={12}>
              <TrimVideo onSubmitCompleted={onSubmitCompleted} />
            </Grid>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
}

export default { Trim };
